import {useRef} from 'react';

/**
 * Regular react ref (useRef) but current value is always actual (updates on each component render, i.e function call).
 * This hook can be useful for provide an actual value to some callback and prevent the callback recreate on each render
 */
export function useActualRef<T>(actualValue: T) {
	const ref = useRef(actualValue);
	ref.current = actualValue;
	return ref;
}
useActualRef.displayName = 'useActualRef';
